import { render } from "./vcompanymoneydetails.vue?vue&type=template&id=3503c7b2&scoped=true"
import script from "./vcompanymoneydetails.vue?vue&type=script&lang=js"
export * from "./vcompanymoneydetails.vue?vue&type=script&lang=js"

import "./vcompanymoneydetails.vue?vue&type=style&index=0&id=3503c7b2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3503c7b2"]])

export default __exports__